import React from 'react';

type PaginatorProps = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

const Paginator = ({ currentPage, totalPages, onPageChange }: PaginatorProps) => {
  const handleGoToPage = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  return (
    <div className="mt-8 px-4">
      <div className="relative flex items-center">
        {/* Testo a sinistra: sempre visibile */}
        <div className="text-textMuted text-sm font-medium absolute left-0">
          Pagina {currentPage} di {totalPages}
        </div>

        {/* Bottoni centrati: visibili solo se più di 1 pagina */}
        {totalPages > 1 && (
          <div className="flex justify-center w-full space-x-2">
            <button
              className="px-3 py-1 rounded-lg bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover text-sm"
              onClick={() => handleGoToPage(1)}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>

            <button
              className="px-3 py-1 rounded-lg bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover text-sm"
              onClick={() => handleGoToPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &lsaquo;
            </button>

            {(() => {
  const pageNumbers = [];
  const start = Math.max(1, currentPage - 2);
  const end = Math.min(totalPages, currentPage + 2);

  if (start > 1) {
    pageNumbers.push(
      <span key="start-ellipsis" className="px-2 text-sm text-gray-500">...</span>
    );
  }

  for (let i = start; i <= end; i++) {
    const isActive = i === currentPage;
    pageNumbers.push(
      <button
        key={i}
        onClick={() => handleGoToPage(i)}
        className={`px-3 py-1 rounded-lg text-sm font-medium transition
          ${isActive
            ? 'bg-gray-300 text-textPrimary font-semibold'
            : 'bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover'}
        `}
      >
        {i}
      </button>
    );
  }

  if (end < totalPages) {
    pageNumbers.push(
      <span key="end-ellipsis" className="px-2 text-sm text-gray-500">...</span>
    );
  }

  return pageNumbers;
})()}


            <button
              className="px-3 py-1 rounded-lg bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover text-sm"
              onClick={() => handleGoToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &rsaquo;
            </button>

            <button
              className="px-3 py-1 rounded-lg bg-buttonPrimaryBg text-buttonPrimaryText hover:bg-buttonPrimaryHover text-sm"
              onClick={() => handleGoToPage(totalPages)}
              disabled={currentPage === totalPages}
            >
              &raquo;
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Paginator;
